import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Model } from '@zayan-erp/home-building';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { ModelImport } from '@zayan-erp/sales';

@Injectable({
  providedIn: 'root'
})
export class ModelService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;
  updatedModel = new BehaviorSubject<void>(undefined);
  updatedModel$ = this.updatedModel.asObservable();

  createModel(model: Omit<Model, 'id' | 'projectName'>): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/Model`,
      { showLoader: true, showMessage: true, message: 'Model created successfully' },
      model
    );
  }

  readModels(): Observable<ModelImport[]> {
    return this.#http.getData(`${this.baseUrl}/Model`, { showLoader: true, showMessage: false });
  }

  updateModel(model: Omit<Model, 'projectName'>): Observable<unknown> {
    return this.#http.putData(`${this.baseUrl}/Model/${model.id}`, model, {
      showLoader: true,
      showMessage: true,
      message: 'Model updated successfully'
    });
  }

  deleteModel(ids: string): Observable<unknown> {
    return this.#http.deleteData(`${this.baseUrl}/Model/${ids}`, {
      showLoader: true,
      showMessage: true,
      message: 'Model deleted successfully'
    });
  }

  bulkDeleteModel(ids: string[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/Model/bulk-delete`,
      { showLoader: true, showMessage: true, message: 'Models deleted successfully' },
      ids
    );
  }

  upsertModels(models: Omit<Model, 'id'>[]): Observable<unknown> {
    return this.#http.postData(
      `${this.baseUrl}/Model/bulk-upsert`,
      { showLoader: true, showMessage: true, message: 'Models upserted successfully' },
      models
    );
  }

  getModelById(id: string): Observable<Model> {
    return this.#http.getData(`${this.baseUrl}/Model/${id}`, { showLoader: true, showMessage: false });
  }
}
